import React from 'react'
import {Context as AuthContext} from '../contexts/Auth'
import {Context as StoreContext} from '../contexts/Store'

import { Navigate, Outlet } from 'react-router-dom'

function PrivateRoute({ component, Loader, ...rest }) {

    const auth = React.useContext(AuthContext)
    return (
        <React.Fragment>
            {auth.loading && Loader}
            {!auth.loading && auth.auth && (<React.Fragment>{component}<Outlet/></React.Fragment>)}
            {!auth.loading && !auth.auth && <Navigate to="/login" replace/>}
        </React.Fragment>
    );
}
function StoreRoute({ component, Loader, ...rest }) {

    const store = React.useContext(StoreContext)
    return (
        <React.Fragment>
            {store.loading && Loader}
            {!store.loading && store.store && (<React.Fragment>{component}<Outlet/></React.Fragment>)}
            {!store.loading && !store.store && <Navigate to="/" replace/>}
        </React.Fragment>
    );
}

const PublicRoutes = { PrivateRoute, StoreRoute }
export default PublicRoutes